import React from 'react';

// Standard "collapse left panel" glyph — rounded rect with a vertical divider near the left.
// Mirrors horizontally (scaleX(-1)) when used as the expand button.
const CollapsePanelIcon: React.FC<{ color?: string; width?: string; height?: string }> = ({
    color = '#6b7280',
    width = '18',
    height = '18',
}) => (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1.5" y="1.5" width="15" height="15" stroke={color} strokeWidth="1.5" />
        <line x1="5.5" y1="1.5" x2="5.5" y2="16.5" stroke={color} strokeWidth="1.5" />
    </svg>
);

export default CollapsePanelIcon;
